import {
  ListItemIcon,
  ListItemText,
  MenuItem,
  CircularProgress,
} from "@material-ui/core";
import { PowerSettingsNew } from "@material-ui/icons";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { singOut } from "../DataNet/DataNetAuth";
import * as ROUTES from "../../constants/routes";

const SingOutMenuItem = () => {
  const { t } = useTranslation();
  const [isClicked, setIsClicked] = useState(false);

  const handleSignOut = () => {
    setIsClicked(true);

    singOut().finally(() => {
      window.location.href = ROUTES.SIGN_IN;
    });
  };

  return (
    <MenuItem button onClick={handleSignOut}>
      <ListItemIcon>
        {isClicked ? (
          <CircularProgress size={22} />
        ) : (
          <PowerSettingsNew color={"primary"} />
        )}
      </ListItemIcon>
      <ListItemText>{t("common.singOut")}</ListItemText>
    </MenuItem>
  );
};

export default SingOutMenuItem;